import React from 'react';

import {assertAndContinue} from 'Asserts';
import {Status} from 'constants/StatusConstants';
import SchemaFieldValueError from 'metadata/SchemaFieldValueError';
import {SchemaFieldRenderData} from 'schemas/fields/SchemaFieldConstants';

import {ComputedState} from './ComputedTagConstants';
import * as ComputedTagUtil from './ComputedTagUtil';

interface ComputedStateTextProps {
  computedState: ComputedState;
  schemaFieldRenderData: SchemaFieldRenderData;
}

/**
 * Renders a computed field with any status other than SUCCEEDED.
 */
export default function ComputedStateText(props: ComputedStateTextProps): JSX.Element | null {
  const {computedState, schemaFieldRenderData} = props;
  assertAndContinue(
    computedState.status !== Status.SUCCEEDED,
    'Expected ComputedStateText to not be used for succeeded computed tag'
  );
  if (computedState.status === Status.FAILED) {
    return (
      <SchemaFieldValueError
        errorLabel="Computing failed"
        schemaFieldRenderData={schemaFieldRenderData}
        messages={[computedState.errorMessage]}
      />
    );
  }
  // Either PENDING or RUNNING state
  return <span>{ComputedTagUtil.COMPUTING_STATUS_TEXT}</span>;
}
